var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "testimonials" }, [
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.squiggleLeft,
          expression: "squiggleLeft"
        }
      ],
      staticClass: "testimonials__squiggle-left"
    }),
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.squiggleRight,
          expression: "squiggleRight"
        }
      ],
      staticClass: "testimonials__squiggle-right"
    }),
    _c("div", { staticClass: "testimonials__container" }, [
      _c(
        "div",
        { staticClass: "testimonials__content" },
        [
          _c("h2", { staticClass: "testimonials__headline" }, [
            _vm._v(_vm._s(_vm.headline))
          ]),
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            _vm._l(_vm.quotes, function(quote, index) {
              return index === _vm.currentQuoteIndex
                ? _c("testimonial-quote", {
                    key: quote.name + "__" + index + "__quote",
                    attrs: { quote: quote }
                  })
                : _vm._e()
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "testimonials__navigation" },
            _vm._l(_vm.quotes, function(quote, index) {
              return _c(
                "button",
                {
                  key: quote.name + "__" + index + "__button",
                  staticClass: "testimonials__navigation-button",
                  class: {
                    "testimonials__navigation-button--active":
                      _vm.currentQuoteIndex === index
                  },
                  on: {
                    click: function($event) {
                      _vm.currentQuoteIndex = index
                    }
                  }
                },
                [
                  _c("span", { staticClass: "u-sr-only" }, [
                    _vm._v(_vm._s("See " + quote.name + "'s testimonial"))
                  ]),
                  _c("responsive-image", {
                    staticClass: "testimonials__navigation-button-image",
                    attrs: { src: quote.profileImage }
                  })
                ],
                1
              )
            }),
            0
          )
        ],
        1
      ),
      ["desktop", "hd"].includes(_vm.$mq)
        ? _c(
            "div",
            { staticClass: "testimonials__featured-image-container" },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                _vm._l(_vm.quotes, function(quote, index) {
                  return _vm.currentQuoteIndex === index
                    ? _c("responsive-image", {
                        key: quote.name + "__" + index + "__image",
                        staticClass: "testimonials__featured-image",
                        attrs: {
                          "aspect-ratio": "429:520",
                          src: quote.featuredImage.src,
                          alt: quote.featuredImage.alt
                        }
                      })
                    : _vm._e()
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }